import { create } from 'zustand';
import { messagesApi } from './api';

export const useMessagingStore = create((set, get) => ({
    unreadCount: 0,
    isLoading: false,

    fetchUnreadCount: async () => {
        try {
            // Prevent duplicate fetches if already loading
            if (get().isLoading) return;
            
            set({ isLoading: true });
            const { unread_count } = await messagesApi.getUnreadCount();
            set({ unreadCount: unread_count, isLoading: false });
        } catch (error) {
            console.error('Failed to fetch unread count:', error);
            set({ isLoading: false });
        }
    },

    setUnreadCount: (count) => set({ unreadCount: count }),
    
    incrementUnreadCount: () => set((state) => ({ unreadCount: state.unreadCount + 1 })),
    
    decrementUnreadCount: () => set((state) => ({ unreadCount: Math.max(0, state.unreadCount - 1) }))
}));
